module.exports = __webpack_public_path__ + "img/plus.3131b188.svg";